import one from './1.js';
import two from './2.js';
import three from './3.js';
import four from './4.js';
import five from './5.js';

const aboutDescriptionDB = [
	one,two,three,four,five
];

export default aboutDescriptionDB;